import { MatDialog } from '@angular/material/dialog';
import { ApplicationScreen } from 'src/app/application-navigator/application-screen';
import { Component } from '@angular/core';
import { Shipment, ShipmentService } from 'src/app/acumatica/EntityServices/Shipment.service';
import { AlertDialog } from 'src/app/common/alert-dialog/alert-dialog.component';
import { SalesOrder, SalesOrderService } from 'src/app/acumatica/EntityServices/SalesOrder.service';

@Component({
  selector: 'app-log-data-reprocessor',
  templateUrl: './log-data-reprocessor.component.html',
  styleUrls: ['./log-data-reprocessor.component.css']
})
export class LogDataReprocessorComponent extends ApplicationScreen {
  pageTitle = 'Shipment Log Reprocessor'
  public data: string = '';
  public doAllowances: boolean = true;
  public feedback: string = '';

  constructor(
    private shipments: ShipmentService,
    private salesOrders: SalesOrderService,
    private dialog: MatDialog
  ) {
    super();
  }

  parseShipment(): Shipment {
    let shipment: Shipment = JSON.parse(this.data);

    shipment.Details = shipment.Details.sort((a, b) => a.LineNbr! - b.LineNbr!);

    delete (shipment.__id);
    shipment.Details.forEach(detail => {
      delete (detail.__id);
      detail.SuggestedPickingSource = null;
      detail.Allocations.forEach(alloc => {
        delete (alloc.__id);

        if (!this.doAllowances) {
          if (alloc.EOR) {
            alloc.Qty -= alloc.EORQty || 0;
            alloc.EOR = false;
            alloc.EORQty = null;
          }
          if (alloc.PCS) {
            alloc.Qty -= alloc.PCSQty || 0;
            alloc.PCS = false;
            alloc.PCSQty = null;
          }
          if (alloc.FLA) {
            alloc.Qty -= alloc.FLAQty || 0;
            alloc.FLA = false;
            alloc.FLAQty = null;
          }
        }
        if (alloc.FLAImgs === undefined) alloc.FLAImgs = [];
      })
    });

    console.log(shipment);

    return shipment;
  }

  // processShipment() {
  //   let shipment = this.parseShipment();

  //   this.shipments.completeShipmentPicking(shipment, undefined, true, status => {
  //     console.log(status.toString());
  //     this.feedback = status.toString();
  //   }).subscribe(() => {
  //     this.dialog.open(AlertDialog, { data: { message: 'Shipment has been updated', buttonText: 'OK' } });
  //   });
  // }

  processRepSO() {
    let salesOrder = Object.assign(new SalesOrder(), JSON.parse(this.data));
    this.salesOrders.put(salesOrder).subscribe(() => { });
  }
}
